
// Get Window Width and Height
jQuery(document).ready(function ($) {
  var windowWidth = $(window).outerWidth();
  var windowHeight = $(window).height();

  if (windowWidth < 768) {
    //  Navigation on mobile on/off
    var menuButton = document.querySelector('.menu_btn')

    //if (menuButton){
    //  menuButton.addEventListener('click', function() {
    //    menuOn.classList.toggle('menu-active')
    //    menuButton.classList.toggle('active')
    //  });
    //}

    // Sub menu open on click
      $('.siteMenu .menu-item-has-children').on('click', function() {
          $(this).children().last().slideToggle();
          $(this).toggleClass('active');
      });

    // Open search on click
      $('.header .search-button').on('click', function() {
          $(this).next().slideToggle();
          $(this).toggleClass('active');
      });

    // Open menu on click
      var menuOn = $('body');

      $('.header .menu_btn').on('click', function() {
          $(this).next().slideToggle();
          $(this).toggleClass('active');
          $(menuOn).toggleClass('active-menu');
      });
  }
});
//# sourceMappingURL=navigation.js.map
